import {AdBannerEventType} from '@core-client/ads/banner/AdBannerEventType';
import {getBottomPosAboveFooterBanner} from '../../../banners/position';

import {log} from '../util/BannerCommon';

import type {IBannerHookSettings} from './BaseBannerHook';
import {BannerWithOptionsHook} from './BannerWithOptionsHook';
import type {IBannerJson} from './IBannerJson';

export class EmergedFooterBannerHook extends BannerWithOptionsHook {
    constructor(settings: IBannerHookSettings<IBannerJson>) {
        log('EmergedFooterBannerHook init');
        super(settings);
    }

    override activate() {
        super.activate();
        const elem = this.element;

        const shift = getBottomPosAboveFooterBanner();
        if (shift > 0) {
            // Смещаем контейнер баннера через `transform`, поскольку у рекламного баннера задано `position: fixed`
            elem.style.transform = `translateY(-${shift}px)`;
        }

        this.listenAdLoaded();
        elem.addEventListener(AdBannerEventType.mrgShowed, this.onAdShown);
        elem.addEventListener(AdBannerEventType.mrgClosed, this.onAdClosed);
    }

    override deactivate() {
        const elem = this.element;
        this.unlistenAdLoaded();
        elem.removeEventListener(AdBannerEventType.mrgShowed, this.onAdShown);
        elem.removeEventListener(AdBannerEventType.mrgClosed, this.onAdClosed);
        super.deactivate();
    }

    override getAdLoadEventList() {
        return [AdBannerEventType.mrgRenderInit];
    }
}
